import Vue from 'vue'
import { Storage } from '@/modules/plugins/storage'
import { Translations } from '@/api/models/translations'

const state = {
    locale: Storage.getItem('locale', false) || process.env.VUE_APP_LOCALE,
    timezone: process.env.VUE_APP_TIMEZONE || 'Europe/Budapest',
    locales: [],
    translation: '',
}

const mutations = {
    UPDATE(state, locale) {
        state.locale = locale
        Storage.setItem('locale', locale)
        this._vm.$moment.updateLocale(state.locale)
        this._vm.$i18n.set(state.locale)
    },
    SET_LOCALES(state, locales) {
        state.locales = locales
    },
    SET_LOCALE(state, locale) {
        state.locale = locale
    },
}

const actions = {
    async initLocales({ dispatch, commit, state }, config) {
        if (!state.locale) commit('SET_LOCALE', config.default_locale)
        commit('UPDATE', state.locale)
        await dispatch('loadLocales', config.available_locales)
        dispatch('localeReset')
    },

    async loadLocales({ dispatch }, available) {
        const translations = new Translations()
        let availableLocales = Object.entries(available).map(async ([locale, value]) => {
            await translations.get(locale, value.version).then((translation) => {
                Vue.i18n.add(locale, translation)
            })
            return locale
        })
        return Promise.all(availableLocales).then((availableLocales) => {
            dispatch('setLocales', availableLocales)
        })
    },

    localeReset({ dispatch, commit }) {
        let locale =
            Storage.getItem('locale', false) || navigator.language || navigator.userLanguage
        if (!this._vm.$i18n.localeExists(locale)) {
            locale = document.documentElement.lang
                ? document.documentElement.lang
                : process.env.VUE_APP_LOCALE
        }
        commit('UPDATE', locale)
        dispatch('setCalendar', Vue.prototype.$calendarFormat1(locale))
    },

    setLocales({ commit }, locales) {
        commit('SET_LOCALES', locales)
    },

    localeSet({ dispatch, commit, getters }, locale) {
        if (this._vm.$i18n.localeExists(locale) && getters.languageSelectorAvailable) {
            commit('UPDATE', locale)
            dispatch('setCalendar', Vue.prototype.$calendarFormat1(locale))
        }
    },

    setCalendar({ state }, format) {
        Vue.moment.updateLocale(state.locale, {
            calendar: format,
        })
    },
}

const getters = {
    locale: (state) => state.locale,
    locales: (state) => state.locales,
    translation: (state) => state.translation,
    timezone: (state) => state.timezone,
    languageSelectorAvailable: (state, getters) =>
        ['hu', 'HU'].includes(getters['site/siteLocation']),
}

export default {
    state,
    mutations,
    actions,
    getters,
}
